/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for violation types based on the response format schema.
 * @export
 */
export const ViolationTypeEnum = {
    MsrbRuleG23: 'MSRB Rule G-23',
    Section5SecuritiesAct: 'Section 5 Securities Act',
    Section11SecuritiesAct: 'Section 11 Securities Act',
    Section12A1SecuritiesAct: 'Section 12(a)(1) Securities Act',
    Section12A2SecuritiesAct: 'Section 12(a)(2) Securities Act',
    Section17ASecuritiesAct: 'Section 17(a) Securities Act',
    Section17A1SecuritiesAct: 'Section 17(a)(1) Securities Act',
    Section17A2SecuritiesAct: 'Section 17(a)(2) Securities Act',
    Section17A3SecuritiesAct: 'Section 17(a)(3) Securities Act',
    Section17BSecuritiesAct: 'Section 17(b) Securities Act',
    Rule10b5SecuritiesExchangeAct: 'Rule 10b-5 Securities Exchange Act',
    Rule12b20SecuritiesExchangeAct: 'Rule 12b-20 Securities Exchange Act',
    Rule13a1SecuritiesExchangeAct: 'Rule 13a-1 Securities Exchange Act',
    Rule13a11SecuritiesExchangeAct: 'Rule 13a-11 Securities Exchange Act',
    Rule13a13SecuritiesExchangeAct: 'Rule 13a-13 Securities Exchange Act',
    Rule13b21SecuritiesExchangeAct: 'Rule 13b2-1 Securities Exchange Act',
    Rule13b22SecuritiesExchangeAct: 'Rule 13b2-2 Securities Exchange Act',
    Rule14a9SecuritiesExchangeAct: 'Rule 14a-9 Securities Exchange Act',
    Rule15c31SecuritiesExchangeAct: 'Rule 15c3-1 Securities Exchange Act',
    Section10BSecuritiesExchangeAct: 'Section 10(b) Securities Exchange Act',
    Section13ASecuritiesExchangeAct: 'Section 13(a) Securities Exchange Act',
    Section13B2ASecuritiesExchangeAct: 'Section 13(b)(2)(A) Securities Exchange Act',
    Section13B2BSecuritiesExchangeAct: 'Section 13(b)(2)(B) Securities Exchange Act',
    Section15A1SecuritiesExchangeAct: 'Section 15(a)(1) Securities Exchange Act',
    Section15BC1SecuritiesExchangeAct: 'Section 15B(c)(1) Securities Exchange Act',
    Section15DSecuritiesExchangeAct: 'Section 15(d) Securities Exchange Act',
    Section16ASecuritiesExchangeAct: 'Section 16(a) Securities Exchange Act',
    Section20BSecuritiesExchangeAct: 'Section 20(b) Securities Exchange Act',
    Section21CSecuritiesExchangeAct: 'Section 21C Securities Exchange Act',
    Section2061AdvisersAct: 'Section 206(1) Advisers Act',
    Section2062AdvisersAct: 'Section 206(2) Advisers Act',
    Section2064AdvisersAct: 'Section 206(4) Advisers Act',
    Rule20648AdvisersAct: 'Rule 206(4)-8 Advisers Act',
    Section302SarbanesOxleyAct: 'Section 302 Sarbanes-Oxley Act',
    Section404SarbanesOxleyAct: 'Section 404 Sarbanes-Oxley Act',
    Section906SarbanesOxleyAct: 'Section 906 Sarbanes-Oxley Act',
    _15USC78dd1AntiBriberyFcpa: '15 U.S.C. § 78dd-1 Anti-Bribery FCPA',
    _15USC78mB2BooksAndRecordsFcpa: '15 U.S.C. § 78m(b)(2) Books and Records FCPA'
} as const;
export type ViolationTypeEnum = typeof ViolationTypeEnum[keyof typeof ViolationTypeEnum];


export function instanceOfViolationTypeEnum(value: any): boolean {
    for (const key in ViolationTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(ViolationTypeEnum, key)) {
            if (ViolationTypeEnum[key as keyof typeof ViolationTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ViolationTypeEnumFromJSON(json: any): ViolationTypeEnum {
    return ViolationTypeEnumFromJSONTyped(json, false);
}

export function ViolationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViolationTypeEnum {
    return json as ViolationTypeEnum;
}

export function ViolationTypeEnumToJSON(value?: ViolationTypeEnum | null): any {
    return value as any;
}

export function ViolationTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ViolationTypeEnum {
    return value as ViolationTypeEnum;
}

